import { getAuthToken } from "@/lib/authStorage";
import { getActiveProfileId } from "@/lib/profileStorage";

/**
 * Attaches Bearer auth and X-Profile-Id to an axios request config.
 */
export function attachApiHeaders(config) {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const profileId = getActiveProfileId();
  if (profileId) {
    config.headers["X-Profile-Id"] = profileId;
  }
  return config;
}
